export const createGameCardInventorySlice = ()=>(set, get)=>({
            gameCardInventory: {
                cardInventory: [],
                setCardInventory: (cardInventory)=>{
                    set({
                        gameCardInventory: {
                            ...get().gameCardInventory,
                            cardInventory: cardInventory
                        }
                    });
                },
                selectedCards: [],
                setSelectedCards: (selectedCards)=>{
                    set({
                        gameCardInventory: {
                            ...get().gameCardInventory,
                            selectedCards: selectedCards
                        }
                    });
                },
                handCardsToDisable: [],
                setHandCardsToDisable: (handCardsToDisable)=>{
                    set({
                        gameCardInventory: {
                            ...get().gameCardInventory,
                            handCardsToDisable: handCardsToDisable
                        }
                    });
                },
                onSelectCardForTrade: undefined,
                setOnSelectCardForTrade: (onSelectCardForTrade)=>{
                    set({
                        gameCardInventory: {
                            ...get().gameCardInventory,
                            onSelectCardForTrade: onSelectCardForTrade
                        }
                    });
                },
                onSelectCardForActionBox: undefined,
                setOnSelectCardForActionBox: (onSelectCardForActionBox)=>{
                    set({
                        gameCardInventory: {
                            ...get().gameCardInventory,
                            onSelectCardForActionBox: onSelectCardForActionBox
                        }
                    });
                }
            }
        });
